import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';

interface Props {
  invoiceId: string;
  invoiceName: string;
  compact?: boolean;
}

/**
 * Opent de factuur-PDF (zelfde layout als het mail-attachment) in een nieuw
 * tabblad. Token in de URL omdat een tabblad geen Authorization-header kan
 * meesturen — zelfde patroon als inbox-bijlagen.
 */
export function InvoicePdfButton({ invoiceId, invoiceName, compact }: Props) {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setToken(data.session?.access_token ?? null);
    });
  }, []);

  if (!token) return null;

  const url = `/api/invoices/pdf?id=${invoiceId}&token=${token}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      title={`Open PDF van ${invoiceName}`}
      className={
        compact
          ? 'inline-flex items-center gap-1 text-xs text-slate-600 hover:text-slate-900'
          : 'inline-flex items-center gap-1.5 text-sm font-medium px-3 py-1.5 rounded border border-slate-300 text-slate-700 hover:bg-slate-50'
      }
    >
      <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
        />
      </svg>
      Open PDF
    </a>
  );
}
